<!-- src/components/Checkout.vue -->
<template>
    <div :class="publicCheckout ? 'rounded m-3' :'' ">
        <b-card>
            <div v-if="publicCheckout">
                <base-logo class="main-logo w-300"></base-logo>
            </div>
            <h3>Checkout</h3>
            <br />  
            <div class="mt-3"></div>
            <base-table-spinner v-if="isLoading && showPageLoader"></base-table-spinner>
            <div class="row" v-else>
                <div class="col-md-6">
                    <b-alert :style="{width: '400px', margin: '10px auto'}" variant="danger" v-if="error" show>{{ error }}</b-alert>
                    <form @submit.prevent="handleSubmit">
                        <div id="stripe-payment-element"><!-- Stripe Card Element will be inserted here --></div>
                        <b-button
                            type="submit"
                            variant="warning"
                            style="color:white;"
                            :disabled="isLoading"
                            >Subscribe Now</b-button>
                    </form>
                </div>
                <div class="col-md-6">
                    <div class="shadow rounded" style="width:440px; margin-left: auto">
                        <h4 style="background-color: #662d91; color: white; padding:10px; text-align: center;">Plan Details</h4>
                        
                        <div class="row p-2 ml-2 pb-5">
                            <div class="col-12 mt-3"></div>
                            <div class="col-7 text-muted" style="font-size: 18px; font-weight: bold;">
                                Profiles to be purchased
                            </div>
                            <div class="col-5 text-right pr-4" style="font-size: 18px; font-weight: bold;">
                                {{ renewQuantity || packageDetails.onboardings.max}}
                            </div>
                            <template v-if="taxPercentage">
                                <div class="col-12 my-3"></div>
                                <div class="col-6 text-muted" style="font-size: 18px; font-weight: bold;">
                                    Subtotal
                                </div>
                                <div class="col-6 text-right pr-4" style="font-size: 18px; font-weight: bold;">
                                    {{ getCurrency(packageDetails) }} {{renewalCheckout ? packageDetails.renewalPrice : packageDetails.firstTimePrice}}
                                </div>
                                <div class="col-12 mt-2"></div>
                                <div class="col-6 text-muted" style="font-size: 18px; font-weight: bold;">
                                    VAT ({{taxPercentage}}%)
                                </div>
                                <div class="col-6 text-right pr-4" style="font-size: 18px; font-weight: bold;">
                                    {{ getCurrency(packageDetails) }} {{ getTaxAmount(packageDetails, true) }}
                                </div>
                            </template>

                            <div class="col-12 mt-2"></div>
                            <div class="col-6 text-muted" style="font-size: 18px; font-weight: bold;">
                                Total
                            </div>
                            <div class="col-6 text-right pr-4" style="color: var(--primary-color); font-size: 18px; font-weight: bold;">
                                {{ getCurrency(packageDetails) }} {{getFinalTotal(packageDetails)}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js';
import request from '@/utils/request'
import { mapGetters } from 'vuex';

export default {
    props: {
        packageId: {
            type: String,
            // required: true,
        },
    },
    computed: {
        ...mapGetters([
            'user',
        ])
    },
    data() {
        return {
            publicCheckout: false,
            renewQuantity: null,
            renewalCheckout: false,
            stripe: null,
            elements: null,
            clientSecret: null,
            packageDetails: null,
            taxPercentage: null,
            error: null,
            paymentElement: null,
            isLoading: true,
            showPageLoader: true,
        };
    },
    async mounted() {
        const search = window.location.search;
        console.log("search", search)
        const token = decodeURIComponent(search.replace("?token=","").trim());
        console.log("token below")
        console.log(token)
        if(!this.packageId && !token) {
            return this.$router.push('/billing');
        }
        let formData;
        if(this.packageId) {
            formData = {
                data: this.$encryptData({
                    packageId: this.packageId,
                    username: this.user.username,
                    timezoneOffset: (new Date()).getTimezoneOffset(),
                })
            }

        } else {
            try {
                this.publicCheckout = true
                const decrypted = this.$decryptData(token)
                console.log('decrypted', decrypted);
                if(!decrypted) {
                    throw new Error('Your link has been expired.')
                }
                this.renewQuantity = decrypted.quantity; 
                this.renewalCheckout = true; 
                formData = {
                        data: this.$encryptData({
                            ...decrypted,
                            renewal: true,
                            timezoneOffset: (new Date()).getTimezoneOffset(),
                        })
                    };
            } catch(e) {
                console.log(e)
                this.$store.commit('setError', 'Your link has been expired.');
                return;
            }
            
        }
        let {clientSecret} = await this.getSetupIntentWithPackage(formData);
        this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_PK);
        this.elements = this.stripe.elements({
            clientSecret 
        });
        this.isLoading = false;
        this.showPageLoader = false;
        this.$nextTick(()=> {
            // const paymentElement = this.elements.create('payment');
            const paymentElement = this.elements.create('payment', {
                    fields: {
                        billingDetails: {
                            address: {
                                country: 'never',
                            }
                        }
                    }
                });

                paymentElement.mount('#stripe-payment-element');
                this.paymentElement = paymentElement;
        })
    },
    methods: {
        getCountryCode() {
            let code = process.env.VUE_APP_COUNTRY_TEMP;
            if(!code) {
                throw new Error("Country code is required")
            }
            code = code.toUpperCase().trim()
            let translate = {
                "UAE": "AE",
                "QATAR": "QA",
                "PK": "PK",
                "UK": "GB",
            }
            if(translate[code]) {
                console.log("country code", translate[code])
                return translate[code]
            }
            console.log("country code 2", code)
            return code
            
        },
        async handleSubmit() {
            try {
                this.isLoading = true;
                let countryCode = this.getCountryCode()

                const { setupIntent, error } = await this.stripe.confirmSetup( {
                    elements: this.elements, 
                    confirmParams: {
                        return_url:  process.env.VUE_APP_URL + 'payment-confirmation',
                        payment_method_data: {
                            billing_details: {address: {country: countryCode } }
                        },
                    },
                    redirect: 'always',
                });

                if (error) {
                    this.error = error.message;
                    this.isLoading = false;
                    return;
                }
                // stripe will automatically redirect.
                // this.$router.push('/payment-confirmation?setup_intent_client_secret=1&redirect_status=succeeded')
            } catch (error) {
                this.error = error.message;
            }
            this.isLoading = false;
        },
        async getSetupIntentWithPackage(formData) {
            try {
                let {data} = await request.post('users/create-setup-intent', formData);
                this.clientSecret = data.clientSecret;
                this.packageDetails = data.packageDetails;
                this.taxPercentage = data.taxPercentage;
                return data
                
            } catch (error) {
                this.error = error.message;
                console.log("error", error)
                this.$store.commit('setError', 'Something went wrong.');
            }
        },
        // getVATAmount(packageDetails){
        //     return  parseFloat(parseFloat( this.renewalCheckout ? packageDetails.renewalPrice : packageDetails.firstTimePrice) * 0.05).toFixed(2);
        // },
        getTaxAmount(packageDetails, roundOff = false){
            const amount = this.taxPercentage ? parseFloat(parseFloat(this.renewalCheckout ? packageDetails.renewalPrice : packageDetails.firstTimePrice)*(this.taxPercentage/100)) : 0
            return roundOff ? amount.toFixed(2) : amount
        },
        getFinalTotal(packageDetails){
            return this.taxPercentage ? 
                parseFloat(parseFloat(this.renewalCheckout ? packageDetails.renewalPrice : packageDetails.firstTimePrice) + this.getTaxAmount(packageDetails)).toFixed(2) :
                parseFloat(this.renewalCheckout ? packageDetails.renewalPrice : packageDetails.firstTimePrice).toFixed(2);
        },
        getCurrency(packageDetails){
            // return packageDetails.currency == 'USD' ? '$' : packageDetails.currency;
            return packageDetails.currency;
        }
    },
};
</script>

<style scoped>
/* Add some basic styling */
form {
    max-width: 400px;
    margin: auto;
}
input, button {
    display: block;
    width: 100%;
    margin: 10px 0;
}
.main-logo {
    display: flex;
    justify-content: center;
}

</style>
